__turbopack_context__.v({
  "logoutButton": "LogoutButton-module__H9fHEa__logoutButton",
  "logoutIcon": "LogoutButton-module__H9fHEa__logoutIcon",
});
